<template>
  <div style="display:flex; margin-top:30px">
    <div class="ageleft">
      <div class="lable">
        <div
          v-for="(item,index) in labledata"
          :key="index"
          :class="{heightlight : lableindex==index}"
          @click="lableArea(index,item)"
        >
          {{item}}
          <div v-if="lableindex==index" class="xian"></div>
        </div>
      </div>
      <div>
        <div v-if="lableindex==0" style="padding: 10px;">
          <div class="basenav1">
            <div class="basenavleft1">基地名称:</div>
            <div class="basenavright1" style="line-height: 30px;">
              <span style="color: rgb(2, 144, 238);">{{baseData.baseName}}</span>
            </div>
          </div>

          <div class="basenav1">
            <div class="basenavleft1">基地地址:</div>
            <div class="basenavright1" style="line-height: 30px;">
              <span style="color: rgb(2, 144, 238);">{{baseData.baseAddress}}</span>
            </div>
          </div>

          <div class="basenav1">
            <div class="basenavleft1">所属地区:</div>
            <div class="basenavright1" style="line-height: 30px;">
              <span style="color: rgb(2, 144, 238);">{{baseData.superiorDeptName}}</span>
            </div>
          </div>

          <div class="basenav1" v-if="baseData.unitAttribute">
            <div class="basenavleft1">单位性质:</div>
            <div class="basenavright1" style="line-height: 30px;">
              <span style="color: rgb(2, 144, 238);" v-if="baseData.unitAttribute==1">行政机关</span>
              <span style="color: rgb(2, 144, 238);" v-if="baseData.unitAttribute==2">事业单位</span>
              <span style="color: rgb(2, 144, 238);" v-if="baseData.unitAttribute==3">企业</span>
            </div>
          </div>

          <div class="basenav1">
            <div class="basenavleft1">基地类别:</div>
            <div class="basenavright1" style="line-height: 30px;">
              <span style="color: rgb(2, 144, 238);" v-if="baseData.baseType==1">省直属</span>
              <span style="color: rgb(2, 144, 238);" v-if="baseData.baseType==2">市直属</span>
              <span style="color: rgb(2, 144, 238);" v-if="baseData.baseType==3">县直属</span>
              <span style="color: rgb(2, 144, 238);" v-if="baseData.baseType==4">省警种</span>
              <span style="color: rgb(2, 144, 238);" v-if="baseData.baseType==5">市警种</span>
              <span style="color: rgb(2, 144, 238);" v-if="baseData.baseType==6">县警种</span>
              <span style="color: rgb(2, 144, 238);" v-if="baseData.baseType==7">省外直属</span>
              <span style="color: rgb(2, 144, 238);" v-if="baseData.baseType==8">国外直属</span>
            </div>
          </div>

          <!-- <div class="basenav1" v-if="baseData.airportDistance">
            <div class="basenavleft1">交通条件:</div>
            <div class="basenavright1" style="line-height: 30px;">
              距离机场
              <span style="color: rgb(2, 144, 238);">{{baseData.airportDistance}} </span>
              公里， 距离火车站
              <span
                style="color: rgb(2, 144, 238);"
              >{{baseData.trainDistance}} </span>
              公里，
              乘车路线
              <span
                style="color: rgb(2, 144, 238);"
              >{{baseData.transit}}</span>
            </div>
          </div>-->

          <div class="basenav1">
            <div class="basenavleft1" style="margin-left: 1em">联系人:</div>
            <div class="basenavright1" style="line-height: 30px;width:150px">
              <span style="color: rgb(2, 144, 238);">{{baseData.linkMan}}</span>
            </div>
            <div class="basenavleft1">联系电话:</div>
            <div class="basenavright1" style="line-height: 30px;width:150px">
              <span style="color: rgb(2, 144, 238);">{{baseData.linkPhone}}</span>
            </div>
            <div class="basenavleft1">学员容量:</div>
            <div class="basenavright1" style="line-height: 30px;width:150px">
              <span style="color: rgb(2, 144, 238);">{{baseData.baseNum}}</span> 人
            </div>
          </div>

          <div class="basenav1">
            <div class="basenavleft1">编制人数:</div>
            <div class="basenavright1" style="line-height: 30px;width:150px">
              <span style="color: rgb(2, 144, 238);">{{baseData.preparationNum}}</span>名
            </div>
            <div class="basenavleft1">专职教官:</div>
            <div class="basenavright1" style="line-height: 30px;width:150px">
              <span style="color: rgb(2, 144, 238);">{{baseData.administrativeNum}}</span>名
            </div>
            <!-- <div class="basenavleft1">工勤编制 :</div>
            <div class="basenavright1" style="line-height: 30px;width:150px">
              <span style="color: rgb(2, 144, 238);">{{baseData.workersNum}}</span>名
            </div>-->
          </div>
        </div>
        <div v-if="lableindex==1">
          <div v-if="buildData!==null" style="padding:10px">
            <el-table ref="buildData" :key="tableKey" :data="buildData" border style="width:100%">
              <el-table-column
                min-width="100px"
                min-height="140px"
                :label="'名称'"
                align="center"
                prop="name"
              ></el-table-column>
              <el-table-column
                min-width="100px"
                width="300px"
                min-height="140px"
                :label="'数量'"
                :show-overflow-tooltip="true"
                align="center"
                prop="cnt"
              ></el-table-column>
              <el-table-column
                min-width="100px"
                min-height="140px"
                :label="'总占地面积'"
                align="center"
                prop="bigSize"
              ></el-table-column>
              <el-table-column
                min-width="100px"
                min-height="140px"
                :label="'人数容量'"
                align="center"
                prop="peoNum"
              ></el-table-column>
              <el-table-column
                min-width="100px"
                min-height="140px"
                :label="'配套设施'"
                align="center"
                prop="remark"
              ></el-table-column>
            </el-table>
            <div style="text-align:center;margin-top:10px">
              <pagination
                v-show="buildcount1>0"
                :total="buildcount1"
                :autoScroll="false"
                :layout="'total, prev, pager, next, jumper'"
                :page.sync="listQueryBuild.page"
                :limit.sync="listQueryBuild.limit"
                @pagination="handleCurrentbuildChange"
              />
            </div>
          </div>
          <div v-else class="datanulll">
            <nodata></nodata>
          </div>
        </div>
        <div v-if="lableindex==2">
          <div v-if="placeData!==null" style="padding:10px">
            <el-table ref="WZlist" :key="tableKey" :data="placeData" border style="width:100%">
              <el-table-column
                min-width="100px"
                min-height="140px"
                :label="'物资名称'"
                align="center"
                prop="name"
              ></el-table-column>
              <el-table-column
                min-width="100px"
                width="300px"
                min-height="140px"
                :label="'数量'"
                align="center"
                prop="cnt"
              ></el-table-column>
              <el-table-column
                min-width="100px"
                min-height="140px"
                :label="'配套设施'"
                align="center"
                :show-overflow-tooltip="true"
                prop="remark"
              ></el-table-column>
            </el-table>
            <div style="text-align:center;margin-top:10px">
              <pagination
                v-show="placeCount>0"
                :total="placeCount"
                :autoScroll="false"
                :layout="'total, prev, pager, next, jumper'"
                :page.sync="listQueryWZ.page"
                :limit.sync="listQueryWZ.limit"
                @pagination="handleCurrentwzChange"
              />
            </div>
          </div>
          <div v-else class="datanulll">
            <nodata></nodata>
          </div>
        </div>

        <!-- <div v-if="lableindex==3">
          <div class="withreview">
              <el-form
                  :model="reviewForm"
                  :rules="rules"
                  ref="ruleForm"
                  label-width="100px"
                  class="demo-ruleForm"
              >
                  <div style="display:flex;justify-content: space-between;">
                  </div>
                  <div style="display:flex;justify-content: space-between;">
                  <el-form-item prop="message" style="margin-top:8px;flex:4">
                      <el-input
                      type="textarea"
                      v-model="reviewForm.message"
                      ref="message"
                      placeholder="请对基地发表你的评价吧！"
                      :maxlength="100"
                      ></el-input>
                  </el-form-item>
                  <el-form-item style="text-align:center;flex:1;padding-top:8px">
                      <el-button type="primary" style="height:50px" @click="submitForm('ruleForm')">发表评论</el-button>
                  </el-form-item>
                  </div>
              </el-form>
          </div>
          <div class="introducel" v-if="reviewData.length!==0">
              <div class="gaishu" v-for="(item,index) in reviewData" :key="index">
                  <img class="gaiimg" :src="item.photo" />
                  <div class="gaisuflex">
                    <div class="gaisuname">{{item.createName}}</div>
                    <div class="gaisutext">{{item.message}}</div>
                    <div class="giveclbox">
                        <div></div>
                        <span class="give-time">{{item.createTime}}</span>
                    </div>
                  </div>
              </div>
          </div>
          <div v-else>
              <nodata></nodata>
          </div>
          <div class="pageblock">
              <el-pagination
                  background
                  prev-text="上一页"
                  next-text="下一页"
                  layout="total,prev, pager, next,jumper"
                  :page-size="listQuery.limit"
                  :current-page.sync="listQuery.page"
                  :total="dataCount"
                  @current-change="handleCurrentChange"
                  @size-change="handleSizeChange"
                  v-if="dataCount>0"
              ></el-pagination>
          </div>
        </div>-->
      </div>
    </div>
    <div class="ageright">
      <div class="agerightheight">
        <div @click="baseUse()" class="baseUse">基地使用预约申请</div>
        <!-- <div>
          <img src="../../../../assets/train/u1265.svg" alt />
          <div>收藏</div>
        </div>-->
      </div>
      <div
        style="background-color: #fff;padding:10px 0;max-height: 550px;overflow-y: auto;overflow-x: hidden;"
      >
        <div class="agerightanv" v-for="(item,index) in linkData" :key="index">
          <img src="../../../../assets/teacher/teacherpeople.png" alt style="margin-top:10px" />
          <div>
            <div style="color:red;font-weight:700">
              <span>{{item.dicTypeName}}</span>
            </div>
            <div>联系人：{{item.name}}</div>
            <div class="phone" :title="item.phone">电话：{{item.phone}}</div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="基地使用预约申请"
      :visible.sync="baseDialog"
      width="40%"
      destroy-on-close
      v-if="baseDialog"
    >
      <el-form ref="tempRef" :model="useObj" :rules="passRules" label-width="120px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="培训班名称" prop="trainName">
              <el-input v-model="useObj.trainName"></el-input>
            </el-form-item>

            <el-form-item label="培训时间" prop="time">
              <el-date-picker
                style="width:245px"
                v-model="useObj.time"
                type="daterange"
                value-format="yyyy-MM-dd HH:mm:ss"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="承办部门" prop="deptName">
              <el-input v-model="useObj.deptName"></el-input>
            </el-form-item>

            <el-form-item label="人数" prop="peoNum">
              <el-input type="number" v-model.number="useObj.peoNum"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="申请理由" prop="reason">
          <el-input type="textarea" :rows="2" placeholder="请输入理由" v-model="useObj.reason" clearable></el-input>
        </el-form-item>

        <el-form-item label="申请内容">
          <el-checkbox-group v-model="useObj.type">
            <el-checkbox label="基地"></el-checkbox>
            <el-checkbox label="宿舍"></el-checkbox>
            <el-checkbox label="物资"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="baseDialog = false">取 消</el-button>
        <el-button v-if="dataState" type="primary" @click="subuserDialog('tempRef')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as trainapi from '@/api/train/index';
import Pagination from '@/components/Pagination';
import { getInfo } from '@/utils/auth';
export default {
  components: {
    Pagination,
  },
  props: {
    // buildData:Array,
    baseData: Object,
    // placeData:Array,
    // linkData:Array,
    // buildcount1:Number,
    // placeCount:Number
  },
  data() {
    return {
      baseDialog: false,
      tableKey: 0,
      labledata: ['基础信息', '基本建筑设施', '物资信息'], //,'基地评价'
      lableindex: 0,
      buildData: [], //建筑数据
      buildcount1: 0,
      placeData: [], //物资数据
      placeCount: 0,
      linkData: [], //联系人数据
      listQueryBuild: {
        page: 1,
        limit: 10,
        baseId: 0,
        name: '',
      },
      listQueryWZ: {
        page: 1,
        limit: 10,
        baseId: 0,
        name: '',
        State: 0,
      },
      reviewForm: {
        id: 0,
        baseId: this.$route.query.id * 1,
        message: '',
        // createTime: '2021-03-15T06:31:15.611Z',
        createId: '',
        createName: '',
        photo: '',
        // updateTime: '2021-03-15T06:31:15.611Z',
        // updateId: 0,
        // isDelete: true,
      },
      rules: {
        message: { required: true, message: '请输入您的评论', trigger: 'blur' },
      },
      dataCount: 1,
      reviewData: [],
      listQuery: {
        page: 1,
        limit: 5,
        baseId: this.$route.query.id * 1,
        key: null,
      },
      useObj: {
        type: [],
        time: '',
        baseId: this.$route.query.id * 1,
        trainName: '',
        deptName: '',
        peoNum: '',
        reason: '',
        beginTime: '',
        endTime: '',
        contents: '',
        createId: '',
        createName: '',
      },
      dataState: true,
      passRules: {
        reason: { required: true, message: '请输入申请理由', trigger: 'blur' },
        trainName: {
          required: true,
          message: '请输入培训班名称',
          trigger: 'blur',
        },
        time: { required: true, message: '请输入起止时间', trigger: 'blur' },
        deptName: {
          required: true,
          message: '请输入承办部门',
          trigger: 'blur',
        },
        peoNum: {
          required: true,
          message: '请输入培训班人数',
          trigger: 'blur',
        },
      },
    };
  },
  created() {
    this.getLeader();
    this.TrainBaseJzssLoad();
    this.TrainBaseWzLoad();
    this.getreviewList();
  },
  methods: {
    lableArea(index, item) {
      this.lableindex = index;
    },
    getLeader() {
      //获取联系人
      trainapi.getLeader({ baseId: this.$route.query.id }).then((res) => {
        this.linkData = res.result;
      });
    },
    TrainBaseJzssLoad() {
      //获取基地建设
      this.listQueryBuild.baseId = this.$route.query.id;
      trainapi.TrainBaseJzssLoad(this.listQueryBuild).then((res) => {
        this.buildData = res.data;
        this.buildcount1 = res.count;
      });
    },
    TrainBaseWzLoad() {
      //获取物资
      this.listQueryWZ.baseId = this.$route.query.id;
      trainapi.TrainBaseWzLoad(this.listQueryWZ).then((res) => {
        this.placeData = res.data;
        this.placeCount = res.count;
      });
    },
    handleCurrentbuildChange(val) {
      this.listQueryBuild.page = val.page;
      this.listQueryBuild.limit = val.limit;
      this.TrainBaseJzssLoad();
    },
    handleCurrentwzChange(val) {
      this.listQueryWZ.page = val.page;
      this.listQueryWZ.limit = val.limit;
      this.TrainBaseWzLoad();
    },
    // 分页组件的页数跳转方法
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getreviewList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getreviewList();
    },
    getreviewList() {
      trainapi.TrainBaseTalkLoad(this.listQuery).then((res) => {
        this.reviewData = res.data;
        this.dataCount = res.count;
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.reviewForm.createId = this.$store.state.User.ids * 1;
          this.reviewForm.createName = JSON.parse(
            this.$store.state.User.infos
          ).name;
          this.reviewForm.photo = JSON.parse(
            this.$store.state.User.infos
          ).photo;
          trainapi.TrainBaseTalkAdd(this.reviewForm).then((res) => {
            if (res.code == 200) {
              this.getreviewList();
              this.reviewForm.message = '';
              this.$notify({
                title: '成功',
                message: '评论成功',
                type: 'success',
              });
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    baseUse() {
      if (getInfo('tokens')) {
        this.baseDialog = true;
      } else {
        window.clikLogin();
      }
    },
    subuserDialog(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.useObj.createId = this.$store.state.User.ids * 1;
          this.useObj.createName = JSON.parse(
            this.$store.state.User.infos
          ).name;
          this.useObj.beginTime = this.useObj.time[0];
          this.useObj.endTime = this.useObj.time[1];
          this.useObj.contents = this.useObj.type.join(',');
          trainapi.TrainBaseYyAdd(this.useObj).then((res) => {
            this.$notify({
              title: '成功',
              message: '提交成功',
              type: 'success',
            });
            (this.useObj = {
              type: [],
              time: '',
              baseId: this.$route.query.id * 1,
              trainName: '',
              deptName: '',
              peoNum: '',
              reason: '',
              beginTime: '',
              endTime: '',
              contents: '',
            }),
              (this.baseDialog = false);
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  },
};
</script>

<style scoped>
/deep/.el-dialog__header {
  padding: 20px;
}
.ageleft {
  width: 900px;
  /* height: 200px; */
  background-color: #fff;
}
.datanulll {
  margin-top: 100px;
}
.lable {
  width: 900px;
  height: 40px;
  border-bottom: solid 1px #ccc;
  margin: 0 auto;
  padding-top: 10px;
  display: flex;
}
.lable > div {
  flex: 1;
  text-align: center;
  line-height: 40px;
  font-size: 18px;
  cursor: pointer;
}
.lable > div:hover {
  color: #409eff;
}
.heightlight {
  color: #409eff !important;
  font-weight: 700;
}
.xian {
  width: 150px;
  border: solid 1px rgb(57, 199, 247);
  margin-left: 45px;
}
.ageright {
  width: 280px;
  /* height: 200px; */
  margin: 0 10px;
  /* box-shadow: 2px 1 5px 1px rgba(215, 215, 215, 35%); */
  /* background-color: #333; */
}
.agerightheight {
  height: 40px;
  background-color: #fff;
  padding-top: 10px;
  display: flex;
}
.agerightheight > div:nth-child(1) {
  width: 160px;
  height: 40px;
  font-size: 18;
  color: #fff;
  text-align: center;
  line-height: 40px;
  margin-left: 20px;
  border-radius: 5px;
  background: linear-gradient(
    to right,
    rgb(245, 118, 0),
    rgb(189, 161, 2)
  ) !important;
}
.agerightheight > div:nth-child(2) {
  width: 40px;
  height: 40px;
  text-align: center;
  /* line-height: 40px; */
  margin-left: 20px;
  border-radius: 5px;
  border: solid 1px orange;
  color: orange;
  background-color: rgb(255, 239, 221);
  /* background: linear-gradient(to right, rgb(245, 118, 0) , rgb(189, 161, 2))!important; */
}
.baseUse {
  cursor: pointer;
}
.basenav {
  margin-top: 10px;
  height: 50px;
  display: flex;
}
.basenavleft {
  width: 150px;
  line-height: 50px;
  font-weight: 700;
  text-align: right;
  font-size: 18px;
}
.basenavright {
  line-height: 25px;
  margin-left: 40px;
  font-size: 18px;
}
.basenav1 {
  margin-top: 10px;
  min-height: 30px;
  display: flex;
}
.basenavleft1 {
  /* width: 180px; */
  line-height: 30px;
  /* font-weight: 700; */
  text-align: right;
  font-size: 16px;
}
.basenavright1 {
  margin-left: 10px;
  font-size: 16px;
  width: 800px;
}
.basenavright2 {
  margin-left: 10px;
  font-size: 16px;
  width: 250px;
}
.agerightanv {
  display: flex;
  margin-bottom: 10px;
}
.agerightanv > img {
  width: 95px;
  height: 95px;
  margin-left: 20px;
  background-color: #ccc;
  border-radius: 50%;
}
.agerightanv > div {
  line-height: 30px;
  margin-left: 10px;
}
.withreview {
  margin-top: 10px;
  height: 60px;
  /* border: solid 1px #f2f2f2; */
  padding: 10px 10px;
}
.withreview /deep/.el-form-item__content {
  margin: 0 !important;
}
.withreview /deep/.el-textarea__inner {
  height: 50px !important;
}
/* 分页 样式*/
.pageblock {
  margin-top: 20px;
  text-align: center;
}
</style>


<style lang="scss" scoped>
.introducel {
  width: 875px;
  background-color: rgba(255, 255, 255, 1);
  margin: 0 auto;
  margin-top: 40px;

  .gaishu {
    text-align: justify;
    text-justify: newspaper;
    word-break: break-all;
    border-radius: 5px;
    background-color: rgba(255, 255, 255, 1);
    box-sizing: border-box;
    box-shadow: 2px 2px 5px rgb(215 215 215 / 35%);
    padding: 10px;
    color: #333333;
    margin-bottom: 25px;
    display: flex;
    // &:first-child {
    //   border-top-color: #e5e9ef;
    //   padding-top: 30px;
    // }
    .gaiimg {
      width: 45px;
      height: 45px;
      border-radius: 50%;
    }
    .gaisuflex {
      flex: 1;
      padding-left: 20px;
      .gaisuname {
        font-size: 17px;
        font-weight: bold;
      }
      .gaisutext {
        font-size: 16px;
        color: #555;
        padding-top: 10px;
        padding-right: 10px;
        line-height: 22px;
      }
      .giveclbox {
        margin-top: 10px;
        display: flex;
        justify-content: space-between;
        .give-time {
          color: rgba(0, 0, 0, 0.349019607843137);
        }
        .givecl {
          display: flex;
          align-items: center;
          margin-top: 10px;
          background-color: #888;
          height: 30px;
          width: 75px;
          border-radius: 15px;
          justify-content: center;
          color: #fff;
          img {
            height: 15px;
            width: 15px;
            margin-right: 5px;
          }
        }
      }
    }
  }
}
.phone {
  white-space: nowrap;
  overflow: hidden;
}
</style>